// extracted by mini-css-extract-plugin
module.exports = {"downloadCharts":"GenerateReport_downloadCharts__15KqH","spinner":"GenerateReport_spinner__3N7fl"};